/**
 * API Keys management endpoints.
 */

import { api } from './client';
import type { ApiResponse } from '../types';

export interface ApiKeyListItem {
  id: number;
  name: string;
  key_preview: string;
  is_active: boolean;
  last_used_at: string | null;
  created_at: string;
}

export interface ApiKeyCreated {
  id: number;
  name: string;
  key: string;
}

export const apiKeysApi = {
  /** List all API keys for the current user (masked previews) */
  list: () =>
    api.get<ApiResponse<ApiKeyListItem[]>>('/auth/api-keys'),

  /** Create a new API key (returns full key once) */
  create: (name: string) =>
    api.post<ApiResponse<ApiKeyCreated>>('/auth/api-keys', { name }),

  /** Soft-revoke an API key */
  revoke: (id: number) =>
    api.post<ApiResponse<null>>(`/auth/api-keys/${id}/revoke`, {}),

  /** Rotate a key: issues a NEW key (returned once) and disables the old row */
  rotate: (id: number) =>
    api.post<ApiResponse<ApiKeyCreated>>(`/auth/api-keys/${id}/rotate`, {}),

  /** Reveal the full key for an existing row (never cached — see useRevealApiKey) */
  reveal: (id: number) =>
    api.get<ApiResponse<ApiKeyCreated>>(`/auth/api-keys/${id}`),

  /** Permanently delete an API key */
  delete: (id: number) =>
    api.delete<ApiResponse<null>>(`/auth/api-keys/${id}`),
};
